module.exports = __webpack_public_path__ + "static/img/meishi.c49664bf.svg";